"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IngestController = _interopRequireDefault(require("../controllers/IngestController"));

var _context = require("../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getController = function getController(props) {
  var canInstantiate = true;

  if (props.disabled) {
    canInstantiate = false;
  }

  if (props.env !== 'prod' && props.env !== 'production') {
    if (!props.project) {
      console.error('When instantiated the Ingest Provider component must be given a project prop.');
      canInstantiate = false;
    }

    if (!props.apiKey) {
      console.error('When instantiated the Ingest Provider component must be given an apiKey prop.');
      canInstantiate = false;
    }

    if (!props.token && !props.allowNoToken) {
      console.error('When instantiated the Ingest Provider component must be given a token prop.');
      canInstantiate = false;
    }
  }

  if (canInstantiate) {
    return (0, _IngestController["default"])(props);
  }
};

var IngestProvider = _react["default"].forwardRef(function (props, ref) {
  var ingestContext = (0, _react.useContext)(_context.IngestContext) || {};
  var controller = getController(props);
  var ingest = (0, _react.useMemo)(function () {
    if (controller) {
      return _objectSpread({}, ingestContext, _defineProperty({}, props.project, controller));
    }

    return _objectSpread({}, ingestContext);
  }, [controller]);
  (0, _react.useEffect)(function () {
    return function () {
      var _controller = getController(props);

      if (_controller || props.disabled && _controller) {
        _controller["delete"]();
      }
    };
  }, [props.project, props.disabled]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      getController: function getController() {
        return ingest[props.project];
      }
    };
  }, [ingest]);
  return _react["default"].createElement(_context.IngestContext.Provider, {
    value: ingest
  }, props.children);
});

IngestProvider.displayName = 'IngestProvider';
IngestProvider.defaultProps = {
  disabled: false,
  env: 'stage'
};
IngestProvider.propTypes = {
  allowNoToken: _propTypes["default"].bool,
  apiKey: _propTypes["default"].string.isRequired,
  data: _propTypes["default"].object,
  debounce: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  env: _propTypes["default"].string,
  ingestType: _propTypes["default"].string,
  maQueuedEvents: _propTypes["default"].number,
  onLog: _propTypes["default"].func,
  product: _propTypes["default"].string,
  productLocation: _propTypes["default"].string,
  project: _propTypes["default"].string.isRequired,
  timestampPropertyName: _propTypes["default"].string,
  token: _propTypes["default"].string,
  userRegion: _propTypes["default"].string
};
var _default = IngestProvider;
exports["default"] = _default;